<template>
    <div id="hedaer-bar">
        <div id="home-header">
          <div id="header-left">
            <div id="header-company">
              <a href="http://www.baidu.com"  target="_blank" style="color: #ffffff;text-decoration: none;">{{ $store.getters.company.companyShortname + '-ERP' }}</a>
            </div>
            <div id="header-station">
              <el-dropdown trigger="click">
                <span id="station-name" class="el-dropdown-link hand-pointer">
                  {{ $store.getters.user.stName }}<i v-if="$store.getters.stationCut.length>0" class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" v-if="$store.getters.stationCut.length>0">
                  <div @click="stationCut" v-if="i < 10" v-for="(station,i) in $store.getters.stationCut" v-bind:key="station.stationId" :id="station.stationId"><el-dropdown-item >{{ station.stationName }}</el-dropdown-item></div>
                  <div @click="showStationCutMore = true"><el-dropdown-item :disabled="$store.getters.stationCut.length>10?false:true" divided>更多</el-dropdown-item></div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div id="header-right">
            <div id="header-ling">
              <el-badge :value="lingCount" :max="9" :hidden="lingShow" class="item">
                <img src="../assets/img/news.png" alt="">
              </el-badge>
            </div>
            <div id="header-user">
              <img src="../assets/img/face/man.png" alt="">                
              <el-dropdown trigger="click">
                <div id="user-name">{{ $store.getters.user.userRealname }}</div>
                <el-dropdown-menu slot="dropdown">
                    <div @click="updatePass = true"><el-dropdown-item>修改密码</el-dropdown-item></div>
                    <div @click="showMySetting = true"><el-dropdown-item>个性化设置</el-dropdown-item></div>
                    <div @click="screenFull"><el-dropdown-item v-if="!isFullscreen">全屏显示</el-dropdown-item></div>
                    <div @click="screenFull"><el-dropdown-item v-if="isFullscreen">关闭全屏</el-dropdown-item></div>
                    <div @click="refresh"><el-dropdown-item>刷新缓存</el-dropdown-item></div>
                    <div @click="showAbout = true"><el-dropdown-item>关于</el-dropdown-item></div>
                    <div @click="showExit = true"><el-dropdown-item>安全退出</el-dropdown-item></div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          
        </div>
        <el-dialog title="关于" :visible.sync="showAbout" width="30%">
          <span>
            <p>软件版本：</p>
            <p>技术支持：</p>
            <p>。。。。。</p>
          </span>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="showAbout = false">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="修改密码" :visible.sync="updatePass" :close-on-click-modal="false" width="30%">
          <span>
            <div idd="login-input">
              <el-row type="flex" justify="center">
                <el-input v-bind:autofocus="true" type="password" placeholder="旧密码" v-model.trim="userPass.oldPass" @blur="$v.userPass.oldPass.$touch()" :class="{checkinput: $v.userPass.oldPass.$error}" clearable>
                </el-input>
              </el-row>
              <el-row class="warning-message"><div v-if="$v.userPass.oldPass.$error">旧密码不能为空</div></el-row>
              <el-row type="flex" justify="center">
                <el-input type="password"  placeholder="新密码" v-model.trim="userPass.newPass" @blur="$v.userPass.newPass.$touch()" :class="{checkinput: $v.userPass.newPass.$error}" clearable>
                </el-input>
              </el-row>
              <el-row class="warning-message"><div v-if="$v.userPass.newPass.$error">新密码不能为空</div></el-row>
              <el-row type="flex" justify="center">
                <el-input type="password" placeholder="确认密码" v-model.trim="userPass.checkPass" @blur="$v.userPass.checkPass.$touch()" :class="{checkinput: $v.userPass.checkPass.$error}" clearable>
                </el-input>
              </el-row>
              <el-row class="warning-message"><div v-show="!$v.userPass.checkPass.sameAsPassword">两次密码不一致</div></el-row>
            </div>
          </span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="updatePass = false">取 消</el-button>
            <el-button :disabled="$v.$invalid" type="primary" :loading="updatingType" @click="updatePassWord">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="退出提示" :visible.sync="showExit" width="30%">
          <span>确定退出吗？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showExit = false">取 消</el-button>
            <el-button type="primary" @click="exit">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="个性化设置" :visible.sync="showMySetting" width="50%">
          <span>
            <p>个性化设置开发中。。。。。</p>
          </span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showMySetting = false">取 消</el-button>
            <el-button type="primary" @click="showMySetting = false">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="切换站点提示" :visible.sync="showStationCut" width="30%">
          <span>切换站点会关闭当前所有以打开页面，确定切换吗？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showStationCut = false">取 消</el-button>
            <el-button type="primary" @click="stationCutOk">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="切换站点" :visible.sync="showStationCutMore" width="40%">      
          <div>
            <el-table
              ref="singleTable"
              size="mini"           
              :data="$store.getters.stationCut.filter(data => !cutStationSearchValue || data.stationName.toLowerCase().includes(cutStationSearchValue.toLowerCase()))"
              highlight-current-row
              @row-click="rowClick"
              style="width: 100%; height: 380px; overflow-y: scroll;">
              <el-table-column
                type="index"
                width="50">
              </el-table-column>
              <el-table-column
                property="stationCode"
                label="编号"
                >
              </el-table-column>
              <el-table-column
                property="stationName"
                label="站点名称"
                >
              </el-table-column>
              <el-table-column
                align="right">
                <template slot="header" slot-scope="scope">
                  <el-input
                    v-model="cutStationSearchValue"
                    size="mini"
                    placeholder="输入站点名称搜索"/>
                </template>                
              </el-table-column>
            </el-table>
            
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showStationCutMore = false">取 消</el-button>
            <el-button type="primary" @click="showStationCut = true">确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
import store from '@/store'
import { required, sameAs } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { updateUserPass, updateUserStation } from '@/api/user'
import { getStationByCutAll } from '@/api/station'
import { Notification, MessageBox } from "element-ui"
import { encrypt, decrypt } from '@/utils/rsaEncrypt'
export default {
  data() {
    return {
      lingShow: true,
      lingCount: 10,
      isFullscreen: false,
      //关于
      showAbout: false,
      //修改密码
      updatePass: false,
      //退出
      showExit: false,
      //修改密码按钮状态
      updatingType: false,
      //个性化设置
      showMySetting: false,
      //切换站点提示
      showStationCut: false,
      //切换站点更多选择
      showStationCutMore: false,
      cutStationId: '',
      userPass: {
        oldPass: '',
        newPass: '',
        checkPass: '',
        rsaOldPass: '',
        rsaNewPass: '',
        rsaCheckPass: ''
      },
      // 切换站点搜索框值
      cutStationSearchValue: ''
      

    }
  },
  created() {
    this.getHeaderBars()
  },
  methods: {
    ...mapActions([     
      'getHeaderBars'
    ]),
    // filterNode(value, data) {
    //     if (!value) return true;
    //     return data.label.indexOf(value) !== -1;
    //   },
    rowClick(row, column, event) {
      this.cutStationId = row.stationId
    },
    exit() {
      store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    refresh() {
      Notification.success({
        title: '缓存刷新成功！',
        duration: 2500
      })
    },
    stationCut(e) {
      this.cutStationId = e.currentTarget.id
      this.showStationCut = true
    },
    stationCutOk() {
      if (this.cutStationId != ''){
        updateUserStation(this.cutStationId).then(res => {
          const code = res.status.code    
          if(code == 200){
            const user = res.data.user
            store.commit('SET_USER', user)
            const stationCut = res.data.stationcut
            store.commit('SET_STATION_CUT', stationCut)
            store.commit('DEL_PAGE_ALL')
            this.showStationCut = false
            this.showStationCutMore = false
          }
        })
        .catch(error => {
          return Promise.reject('error')
        })
        this.cutStationId = ''
      }else{
        Notification.error({
          title: '请选择数据！',
          duration: 2500
        })
      }
    },
    updatePassWord() {
      this.userPass.rsaOldPass = encrypt(this.userPass.oldPass)
      this.userPass.rsaNewPass = encrypt(this.userPass.newPass)
      this.userPass.rsaCheckPass = this.userPass.rsaNewPass
      this.updatingType = true
      updateUserPass(this.userPass).then(res => {
        this.updatingType = false
        const code = res.status.code       
        if(code == 200){
          this.updatePass = false
          Notification.success({
            title: '密码修改成功！',
            duration: 2500
          })
        }
      })
      .catch(error => {
        this.updatingType = false
        return Promise.reject('error')
      })
    },
    screenFull() {
      let element = document.documentElement;
      if (this.isFullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }      
      this.isFullscreen = !this.isFullscreen
    }
  },
  //输入校验
  validations() {
    return {
      userPass: {
        oldPass: {
          required
        },
        newPass: {
          required
        },
        checkPass: {
          required,
          sameAsPassword: sameAs('newPass')
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
    #home-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    height: 54px;
    background: #242528;
    #header-left{
      display: flex;
      flex-direction: row;
      #header-company{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 221px;
        color: #ffffff;
        font-size: 22px;
      }
      #header-station{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 221px;
        #station-name{
          color: #ffffff;
          font-size: 16px;
        }
      }
      
    }
    #header-right{
      display: flex;
      flex-direction: row;

      #header-ling{
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: 300px;
        height: 100%;
      }
      #header-user{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 185px;
        height: 100%;
        background: #323438;
        cursor: pointer;
        #user-name{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 120px;
          color: #ffffff;
        }
      }
    }
    #login-input{
      padding-left: 55px;
      padding-right: 55px;
      padding-bottom:55px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/HeaderBar.vue